import { apiRecords } from './api';
import { Field } from './types';

export const RECORDS_PATH = '/v1/records';

export const saveRecord = (
  eventId: number,
  patientId: number,
  fields: Field[],
) => {
  return apiRecords.post(RECORDS_PATH, { eventId, patientId, fields });
};
